import { createSlice } from "@reduxjs/toolkit";
import {
  fetchProviderSearchSuggestions,
  fetchPracticeSearchSuggestions,
} from "./SearchListAction";
import { getApiErrorMessage } from "../../utils/commonUtilities";

const providerSearchSuggestion = createSlice({
  name: "providerSearchSuggestion",
  initialState: {
    isProviderSearchLoading: false,
    providerSearchItem: [],
    proviserSearchErrmsg: "",
    providerSearchError: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchProviderSearchSuggestions.pending, (state) => {
        state.isProviderSearchLoading = true;
        state.providerSearchError = null;
      })
      .addCase(fetchProviderSearchSuggestions.fulfilled, (state, action) => {
        if (!action.payload.success) {
          state.isProviderSearchLoading = false;
          state.providerSearchError = true;
          state.proviserSearchErrmsg = getApiErrorMessage(action.payload.status);
        } else {
          state.isProviderSearchLoading = false;
          state.providerSearchItem = action.payload?.data?.data?.providerResponseDTO;
        }
      })
      .addCase(fetchProviderSearchSuggestions.rejected, (state, action) => {
        state.isProviderSearchLoading = false;
        state.providerSearchError = action.error.message;
      });
  },
});

const practiceSearchSuggestion = createSlice({
  name: "practiceSearchSuggestion",
  initialState: {
    isPracticeSearchLoading: false,
    practiceSearchItem: [],
    practiceSearchErrmsg: "",
    practiceSearchError: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPracticeSearchSuggestions.pending, (state) => {
        state.isPracticeSearchLoading = true;
        state.practiceSearchError = null;
      })
      .addCase(fetchPracticeSearchSuggestions.fulfilled, (state, action) => {
        if (!action.payload.success) {
          state.isPracticeSearchLoading = false;
          state.practiceSearchError = true;
          state.practiceSearchErrmsg = getApiErrorMessage(action.payload.status);
        } else {
          state.isPracticeSearchLoading = false;
          state.practiceSearchItem = action.payload.data.data.practiceResponseDTO;
        }
        
      })
      .addCase(fetchPracticeSearchSuggestions.rejected, (state, action) => {
        state.isPracticeSearchLoading = false;
        state.practiceSearchError = action.error.message;
      });
  },
});
export const providerSearchSuggestionReducer = providerSearchSuggestion.reducer;
export const practiceSearchSuggestionReducer = practiceSearchSuggestion.reducer;
